export default __webpack_public_path__ + "static/externalImg3-d946bd28402270f0b0b91446763b3565.webp";